/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdatePaymentCollectionDto
 */
export interface CreateUpdatePaymentCollectionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePaymentCollectionDto
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdatePaymentCollectionDto
     */
    collectionDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePaymentCollectionDto
     */
    origin?: CreateUpdatePaymentCollectionDtoOriginEnum | null;
}


/**
 * @export
 */
export const CreateUpdatePaymentCollectionDtoOriginEnum = {
    PatientPortal: 'PatientPortal',
    BatchPayment: 'BatchPayment',
    SinglePayment: 'SinglePayment',
    Receipt: 'Receipt',
    PaidInvoice: 'PaidInvoice'
} as const;
export type CreateUpdatePaymentCollectionDtoOriginEnum = typeof CreateUpdatePaymentCollectionDtoOriginEnum[keyof typeof CreateUpdatePaymentCollectionDtoOriginEnum];


/**
 * Check if a given object implements the CreateUpdatePaymentCollectionDto interface.
 */
export function instanceOfCreateUpdatePaymentCollectionDto(value: object): value is CreateUpdatePaymentCollectionDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateUpdatePaymentCollectionDtoFromJSON(json: any): CreateUpdatePaymentCollectionDto {
    return CreateUpdatePaymentCollectionDtoFromJSONTyped(json, false);
}

export function CreateUpdatePaymentCollectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdatePaymentCollectionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'collectionDate': json['collectionDate'] == null ? undefined : (new Date(json['collectionDate'])),
        'origin': json['origin'] == null ? undefined : json['origin'],
    };
}

export function CreateUpdatePaymentCollectionDtoToJSON(value?: CreateUpdatePaymentCollectionDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'collectionDate': value['collectionDate'] == null ? undefined : ((value['collectionDate'] as any).toISOString()),
        'origin': value['origin'],
    };
}

